/*
 * @Author: tanyaohua
 * @Date: 2019-12-31 13:26:12
 * @Description: 列表图的组件
 */

angular.module('AppAttrInfoModule', []).directive('appAttrInfo', [
    'trsHttpService',
    'trsSelectDocumentService',
    '$stateParams',
    'modalDialog',
    'trsspliceString',
    'messagePublishService',
    function(trsHttpService, trsSelectDocumentService, $stateParams, modalDialog, trsspliceString, messagePublishService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/app/appAttrInfo/appAttrInfo.html',
            replace: true,
            transclude: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.data = {
                        relNewsSelectedItems: [],
                        relSubjectSelectedItems: [],
                        relSubjectGroup: [], // 相关专题分组
                        relSubjectSelectedGroup: [], // 相关专题所选分组
                        selectNewArray: [], // 相关新闻选中数据
                        selectSubjectArray: [], // 相关专题选中数据
                    };
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    messagePublishService.subscribe(
                        'hasGetEditInfo',
                        function(event, data) {
                            // 回显相关稿件
                            $scope.data.relNewsSelectedItems = $scope.list.RELATEDNEWS;
                        },
                        $scope
                    );
                    messagePublishService.subscribe(
                        'packageParams',
                        function(event, data) {
                            $scope.list.RELATEDNEWS = trsspliceString.spliceString($scope.data.relNewsSelectedItems, 'METADATAID', ',');
                        },
                        $scope
                    );
                }

                // 可视化选择弹窗
                $scope.visualChooseWindow = function(type) {
                    trsSelectDocumentService.trsSelectDocument(
                        {
                            siteid: $stateParams.appsiteid,
                            relNewsData: type == 'relSubjectSelectedItems' ? [] : angular.copy($scope.data[type]),
                            position: $stateParams.appplatform,
                            showMetadaId: true,
                            isApp: true,
                            docType: '1',
                            searchSpecialDoc: type == 'relSubjectSelectedItems',
                            isAppNews: type != 'relSubjectSelectedItems',
                            platform: 1,
                        },
                        function(result) {
                            if (type == 'relNewsSelectedItems') {
                                angular.forEach(result, function(value, key) {
                                    value.METADATAID = value.metadataId;
                                    value.LISTTITLE = value.title;
                                });
                                $scope.data[type] = result;
                            } else {
                                var i = 0;
                                var index = $scope.data[type].length;
                                var hasGroupArray = [];
                                queryRelSubjectGroup(result[i], function() {
                                    $scope.data[type] = $scope.data[type].concat(hasGroupArray);
                                });
                            }

                            /**
                             * [queryRelSubjectGroup description] 请求相关专题稿件的分组
                             * @param  {[type]}   item     [description] 当前稿件
                             * @param  {Function} callback [description] 回调函数
                             * @return {[type]}            [description]
                             */
                            function queryRelSubjectGroup(item, callback) {
                                item.METADATAID = item.metadataId;
                                item.LISTTITLE = item.title;
                                var params = {
                                    methodname: 'querySpecialGroupsFromData',
                                    serviceid: 'mlf_specialgroup',
                                    MetaDataId: item.METADATAID,
                                };
                                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                                    if (data.DATA.length === 0) {
                                        modalDialog.alertType('相关专题"' + item.LISTTITLE + '"没有分组', '', 'error', 'confirm');
                                        i++;
                                    } else {
                                        $scope.data.relSubjectGroup[index] = data.DATA;
                                        angular.forEach($scope.data.relSubjectGroup[index], function(value, key) {
                                            value.name = value.SPECIALGROUPNAME;
                                            value.value = value.SPECIALGROUPID;
                                        });
                                        $scope.data.relSubjectSelectedGroup[index] = $scope.data.relSubjectGroup[index][0];
                                        item.SPECIALGROUPID = $scope.data.relSubjectGroup[index][0].SPECIALGROUPID;
                                        hasGroupArray.push(item);
                                        i++;
                                        index++;
                                    }
                                    if (i < result.length) {
                                        queryRelSubjectGroup(result[i], callback);
                                    } else {
                                        callback();
                                    }
                                });
                            }
                        }
                    );
                };

                /**
                 * [queryRelatedNewsByKeyWords description] 查询相关新闻
                 * @return {[type]} [description]
                 */
                $scope.queryRelatedNewsByKeyWords = function() {
                    var DocId = $stateParams.appmetadataid ? $stateParams.appmetadataid : 0;
                    var keywords = [];
                    keywords = trsspliceString.spliceString(angular.copy($scope.data.KEYWORDS), 'name', ';');
                    if (keywords == '') {
                        modalDialog.alertType('暂无关联稿件', '', 'warning', false);
                        return;
                    }
                    var params = {
                        serviceid: 'mlf_appmetadata',
                        methodname: 'queryRelatedNewsByKeyWords',
                        MetaDataId: DocId,
                        ChannelId: $stateParams.appchannelid,
                        KeyWords: keywords,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        var ralNewsLen = angular.copy($scope.data.relNewsSelectedItems).length;
                        if (ralNewsLen >= 5) {
                            return;
                        }
                        angular.forEach(data, function(value, key) {
                            value.LISTTITLE = value.TITLE;
                        });
                        $scope.data.relNewsSelectedItems = darftRemove($scope.data.relNewsSelectedItems, data, 'METADATAID').splice(0, 5);
                        if ($scope.data.relNewsSelectedItems.length == 0) {
                            modalDialog.alertType('暂无关联稿件', '', 'warning', false);
                        }
                    });
                };

                /**
                 * [darftRemove description]数组去重
                 *
                 * @param   {[type]}  selectArray  [selectArray description]当前数组
                 * @param   {[type]}  dataArray    [dataArray description]再次请求出数组
                 * @param   {[type]}  type         [type description]
                 * @param   {[type]}  callback     [callback description]
                 *
                 * @return  {[type]}               [return description]
                 */
                function darftRemove(selectArray, dataArray, type, callback) {
                    var arr = selectArray.concat(dataArray);
                    var lastArr = [];
                    var num = 0;
                    for (var i = 0; i < arr.length; i++) {
                        if (!unique(arr[i][type], lastArr, type)) {
                            lastArr.push(arr[i]);
                        } else {
                            if (angular.isFunction(callback)) {
                                callback(i - num);
                                num++;
                            }
                        }
                    }
                    return lastArr;
                }

                /**
                 * [unique description]
                 * @param   {[type]}  n     [n description]
                 * @param   {[type]}  arr   [arr description]
                 * @param   {[type]}  type  [type description]
                 * @return  {[type]}        [return description]
                 */
                function unique(n, arr, type) {
                    for (var i = 0; i < arr.length; i++) {
                        if (n == arr[i][type]) {
                            return true;
                        }
                    }
                    return false;
                }

                // 选择相关新闻或专题
                $scope.selectManuscript = function(item, type) {
                    if (type == 'relNewsSelectedItems') {
                        if ($scope.data.selectNewArray.indexOf(item) < 0) {
                            $scope.data.selectNewArray.push(item);
                        } else {
                            $scope.data.selectNewArray.splice($scope.data.selectNewArray.indexOf(item), 1);
                        }
                    } else {
                        if ($scope.data.selectSubjectArray.indexOf(item) < 0) {
                            $scope.data.selectSubjectArray.push(item);
                        } else {
                            $scope.data.selectSubjectArray.splice($scope.data.selectSubjectArray.indexOf(item), 1);
                        }
                    }
                };

                /**
                 * [selectAll description]稿件全选
                 *
                 * @param   {[type]}  type  [type description]
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.selectAll = function(type) {
                    if (type == 'selectSubjectArray') {
                        $scope.data.selectSubjectArray =
                            $scope.data.selectSubjectArray.length == $scope.data.relSubjectSelectedItems.length
                                ? []
                                : [].concat($scope.data.relSubjectSelectedItems);
                    } else {
                        $scope.data.selectNewArray =
                            $scope.data.selectNewArray.length == $scope.data.relNewsSelectedItems.length
                                ? []
                                : [].concat($scope.data.relNewsSelectedItems);
                    }
                };

                /**
                 * [manuscriptDelete description]删除已选稿件
                 *
                 * @param   {[type]}  type  [type description]
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.manuscriptDelete = function(type) {
                    var index;
                    if (type == 'relSubjectSelectedItems') {
                        for (var i = 0; i < $scope.data.selectSubjectArray.length; i++) {
                            index = $scope.data.relSubjectSelectedItems.indexOf($scope.data.selectSubjectArray[i]);
                            $scope.data.relSubjectSelectedItems.splice(index, 1);
                        }
                        $scope.data.selectSubjectArray.length = 0;
                    } else {
                        for (var i = 0; i < $scope.data.selectNewArray.length; i++) {
                            index = $scope.data.relNewsSelectedItems.indexOf($scope.data.selectNewArray[i]);
                            $scope.data.relNewsSelectedItems.splice(index, 1);
                        }
                        $scope.data.selectNewArray.length = 0;
                    }
                };

                /**
                 * [selectRelSubjectGroup description]选择相关专题稿件的分组
                 *
                 * @param   {[type]}  item           [item description]
                 * @param   {[type]}  selectedGroup  [selectedGroup description]
                 *
                 * @return  {[type]}                 [return description]
                 */
                $scope.selectRelSubjectGroup = function(item, selectedGroup) {
                    item.SPECIALGROUPID = selectedGroup.value;
                };

                // 清空相关联稿件
                $scope.cleanRelatedNews = function(type) {
                    $scope.data[type] = [];
                    if (type == 'relSubjectSelectedItems') {
                        $scope.data.relSubjectGroup = [];
                        $scope.data.relSubjectSelectedGroup = [];
                    }
                };

                // 删除相关新闻或专题
                $scope.relNewsDelete = function(curIndex, type) {
                    var index = $scope.data[type].indexOf(curIndex);
                    $scope.data[type].splice(index, 1);
                    if (type == 'relSubjectSelectedItems') {
                        $scope.data.relSubjectGroup.splice(index, 1);
                        $scope.data.relSubjectSelectedGroup.splice(index, 1);
                    }
                };

                /**
                 * [updateCKSelection description]题图状态
                 * @param  {[obj]} list [description]稿件对象
                 * @return {[type]}     [description]
                 */
                $scope.updateCKSelection = function(list) {
                    $scope.list.ISSELECTFIGURE = $scope.list.ISSELECTFIGURE === '1' ? '0' : '1';
                };
            },
        };
    },
]);
